import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  bannerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 15,
    border: `1px solid ${colour.grey[500]}`,
    borderRadius: 4,
    margin: '10px 0',
    position: 'relative'
  },
  banner: {
    fontSize: 16,
    color: colour.grey[300],
    paddingLeft: 15
  },
  h1: {
    fontSize: 18,
    fontWeight: 600,
    color: colour.grey[200],
    marginTop: 0,
    marginBottom: 5
  },
  p: {
    margin: 0
  }
});
